<template>
  <div class="tabs_content" v-if="loaded">
    <section>
      <div class="left">
        <detail-entity-info :entity="entity" v-if="entity.id">
          <p v-if="entity.thematic_group_name"><translate class="translate">Vychází z tématické skupiny</translate>: <a @click="openThematicGroupDetail(entity.id_thematic_channel_group)">{{ entity.thematic_group_name}}</a></p>
          <p v-if="entity.channel_group_name"><translate class="translate">Vychází ze skupiny kanálů</translate>: <a @click="openChannelGroupDetail(entity.id_channel_group)">{{ entity.channel_group_name}}</a></p>
        </detail-entity-info>
        <h2 v-translate v-else>Základní údaje</h2>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input
              id="name"
              v-model="entity.name"
              :required="true"
              :disabled="!editableByOperator"
              ref="nameref">
            <translate class="translate">Název carouselu</translate>
          </text-input>
          <operator-select
              v-if="showOperatorSelect"
              v-model="operatorId"
              :options="operatorOptions"
              :disabled="!editable || !!entity.id"
          >
          </operator-select>
          <text-input
              id="defaultweight"
              key="defaultweight"
              v-if="!isSubscriber"
              v-model="entity.default_weight"
              :disabled="!editableByOperator"
              ref="defaultweightref">
            <translate class="translate">Výchozí váha</translate>
          </text-input>
          <checkbox-input
              v-if="!isSubscriber"
              id="isdefault"
              v-model="entity.is_default"
              ref="isdefaultref"
              :disabled="!editableByOperator"
          >
            <translate class="translate">Výchozí carousel</translate>
          </checkbox-input>
          <select-box
              v-if="isSubscriber"
              id="profile"
              v-model="entity.id_subscriber_profile"
              :options="profileOptions"
              ref="profileref"
              :disabled="!editableByGlobal || !!entity.id"
              @input="onProfileChange"
          >
            <translate class="translate">Profil odběratele</translate>
          </select-box>
        </div>
        <div class="field_right">
          <select-box
              id="typeSelect"
              v-model="carouselType"
              @input="onTypeChange"
              :options="typeOptions"
              :disabled="!editableByGlobal || !!entity.id"
              :required="true"
              ref="typeref">
            <translate class="translate">Typ carouselu</translate>
          </select-box>
          <select-box
              id="showVariant"
              v-if="!isChannelType && !isTop10Type"
              v-model="entity.show_variant"
              :options="showVariantOptions"
              :disabled="!editableByOperator || carouselType === 'menu'"
              :required="true"
              @input="onShowVariantChange"
              ref="showVariantref">
            <translate class="translate">Typ výpisu</translate>
          </select-box>
          <text-input
              v-if="!isSubscriber && !isChannelType && !isTop10Type && !isTop10ShowVariant"
              key="dashboard_items_count"
              id="dashboard_items_count"
              v-model="entity.dashboard_items_count"
              help-text="max. 24"
              :disabled="!editableByOperator"
              ref="idref">
            <translate class="translate">Max. počet položek</translate>
          </text-input>
          <text-input
              v-if="isMostViewedType || isTop10Type"
              id="days_back"
              key="days_back"
              v-model="entity.days_back"
              :disabled="!editableByOperator"
              :required="true"
              ref="daysbackref">
            <translate class="translate">Počet dní zpět</translate>
          </text-input>
          <text-input
              v-if="isMostViewedType"
              id="minimal_broadcast_length_minutes"
              v-model="entity.minimal_broadcast_length_minutes"
              :disabled="!editableByGlobal"
              ref="daysbackref">
            <translate class="translate">Minimální délka vysílání v minutách</translate>
          </text-input>
        </div>
        <div class="field field_search" v-if="false">
          <multiselect-searchbox
              v-if="!isChannelType && !isSubscriber"
              :searchFunction="searchService"
              v-model="entity.services"
              :disabled="!editableByGlobal"
              name="service"
          >
            <translate>Navázat na službu</translate>
          </multiselect-searchbox>
        </div>
      </div>
    </section>
    <section v-if="isBroadcastsCustomType || isShowsCustomType">
      <div class="left">
        <h2 v-translate>Způsob výběru</h2>
      </div>
      <div class="right">
        <div class="field checkboxes">
          <radio-input
              id="manual"
              name="selection_mode"
              p-class="field"
              v-model="selectionMode"
              :val="selectionMode"
              :disabled="!editableByGlobal"
          >
            <translate class="translate">Ruční výběr</translate>
          </radio-input>
          <radio-input
              id="channels"
              name="selection_mode"
              p-class="field"
              v-model="selectionMode"
              :val="selectionMode"
              :disabled="!editableByGlobal"
          >
            <translate class="translate">Výběr z kanálů</translate>
          </radio-input>
        </div>
      </div>
    </section>
    <section v-if="isChannelType">
      <div class="left">
        <h2><translate class="translate">Nastavení vazby</translate></h2>
      </div>
      <div class="right">
        <div class="field_left">
          <select-box
              id="thematicGroup"
              v-if="!isSubscriber"
              v-model="entity.id_thematic_channel_group"
              :options="thematicGroups"
              :disabled="!editableByGlobal"
              :required="true"
              ref="thematicgroupref">
            <translate class="translate">Tématická skupina</translate>
          </select-box>
          <select-box
              id="channelGroup"
              v-if="isSubscriber"
              v-model="entity.id_channel_group"
              :options="channelGroups"
              :disabled="!editableByGlobal"
              ref="channelgroupref">
            <translate class="translate">Skupina kanálů</translate>
          </select-box>
        </div>
      </div>
    </section>
    <section v-if="!isSubscriber && isCustomType" key="section_services">
      <div class="left">
        <h2 v-translate>Služby</h2>
        <p>Carousel bude zobrazen pouze Odběratelům s touto Službou.</p>
        <p>Výběr Služby neovlivňuje obsah carouselu.</p>
      </div>
      <div class="right">
        <div class="field field_search">
          <multiselect-searchbox
              :searchFunction="searchService"
              v-model="entity.services"
              :disabled="!editableByGlobal"
              name="service"
          >
            <translate>Navázat na službu</translate>
          </multiselect-searchbox>
        </div>
      </div>
    </section>
    <channel-checkbox-list-section
        v-if="(isCustomType || (isContentCustomType && isChannelsMode)) && afterLoad"
        :search-keys="['name']"
        :prepend-channel-id="false"
        :title="'Kanály' | translate"
        group-id="channels"
        :items="channels"
        name="channels"
        :selected-items="entity.id_channels"
        @toggle-select="onChannelsToggle(arguments[0])"
        :editable="editableByGlobal"
    ></channel-checkbox-list-section>
    <section v-if="!isSubscriber && isShowsCustomType" class="uniform-padding" key="section_shows">
      <div class="left">
        <h2 v-translate>Pořady</h2>
      </div>
      <div class="right">
        <sortable-search-select
            :searchFunction="searchShow"
            :default-data="entity.shows"
            v-model="entity.id_shows"
            :disabled="!editableByGlobal || isChannelsMode"
            :show-id="true"
            name="shows"
        >
          <translate>Vyhledat pořad</translate>
        </sortable-search-select>
        <span v-if="!entity.id_shows.length">Nejsou vybrané žádné pořady</span>
      </div>
    </section>
    <section key="section_broadcasts" v-if="!isSubscriber && isBroadcastsCustomType">
      <div class="left">
        <h2 v-translate>Vysílání</h2>
      </div>
      <div class="right">
        <broadcast-sortable-table
            v-model="entity.id_broadcasts"
            :broadcast-names="broadcastNames"
            :disabled="!editableByGlobal || (isBroadcastsCustomType && isChannelsMode)"
            name="broadcasts"
            @select="$emit('broadcast-search-modal', $event)"
        />
        <span v-if="!entity.id_broadcasts.length">Nejsou vybrané žádné vysílání</span>
      </div>
    </section>
    <section v-if="isCustomType || isMostViewedType">
      <div class="left">
        <h2 v-translate>Formát pořadů</h2>
      </div>
      <checkbox-list
          v-if="settingsLoaded"
          key="formatTags"
          name="format"
          :options="formatTags"
          v-model="idFormat"
          :disabled="!editableByGlobal"
      />
    </section>
    <section key="genres-section" v-if="isCustomType">
      <div class="left">
        <h2 v-translate>Žánry</h2>
      </div>
      <checkbox-list
          v-if="settingsLoaded"
          name="genres"
          key="contentTags"
          :options="contentTags"
          v-model="idContent"
          :disabled="!editableByGlobal"
      />
    </section>
    <section key="rating-section" class="uniform-padding" v-if="isCustomType">
      <div class="left">
        <h2 v-translate>Hodnocení</h2>
      </div>
      <range-slider
          name="ratingSlider"
          v-model="entity.rating"
          :disabled="!editableByGlobal"
          unit="%"
      />
    </section>
    <section key="countries-section" v-if="isCustomType">
      <div class="left">
        <h2 v-translate>Země</h2>
      </div>
      <checkbox-list
          name="countries"
          :options="countries"
          v-model="entity.id_countries"
          :show-select-all="true"
          :disabled="!editableByGlobal"
      />
    </section>
    <section key="year-section" class="uniform-padding" v-if="isCustomType">
      <div class="left">
        <h2 v-translate>Rok uvedení</h2>
      </div>
      <range-slider
          name="yearSlider"
          :range-min="1900"
          :range-max="maxYear"
          v-model="entity.year"
          :disabled="!editable"
          :to-infinity="true"
          :to-infinity-text="$gettext('Současnost')"
      />
    </section>
  </div>
</template>

<script>
import SelectOperatorsBusinessModel from "@/components/mixins/select-operator-business-model";
import DetailEntityInfo from "@/components/common/DetailEntityInfo";
import OperatorSelect from "../../../common/OperatorSelect";
import Message from "@/components/mixins/message.js";
import CheckboxList from "../../../common/CheckboxList.vue";
import ChannelCheckboxListSection from "../../../common/ChannelCheckboxListSection.vue";
import SortableSearchSelect from "../../../common/SortableSearchSelect.vue";
import BroadcastSortableTable from "../../../common/BroadcastSortableTable.vue";
import {iso6391ToIso6392} from "../../../../utils/helpers";

export default {
  name: "BasicInfo",
  components: {
    DetailEntityInfo,
    OperatorSelect,
    CheckboxList,
    ChannelCheckboxListSection,
    SortableSearchSelect,
    BroadcastSortableTable,
  },
  mixins: [SelectOperatorsBusinessModel, Message],
  props: {
    entity: Object,
    editable: Boolean,
    broadcastNames: Object,
  },
  data() {
    return {
      formatTags: null,
      contentTags: null,
      selectedFormatTags: [],
      selectedContentTags: [],
      countries: null,
      settingsLoaded: false,
      afterLoad: false,
      profileOptions: [],
      carouselType: 'custom',
      selectionMode: 'manual',
      selectionModeInitialized: false,
      channelGroups: [],
      thematicGroups: [],
      channels: [],
    };
  },
  created(OperatorService, ServiceService, DashboardCarouselService, SubscriberProfileService) {
    this.setLoadingMessage();
    this.operatorService = OperatorService;
    this.serviceService = ServiceService;
    this.dashboardCarouselService = DashboardCarouselService;
    this.subscriberProfileService = SubscriberProfileService;
    this.getOperators(true)

    this.carouselType = this.entityToCarouselType();
    this.selectionMode = this.entityToSelectionMode();
    this.$nextTick(() => {
      this.selectionModeInitialized = true;
    });

    if(this.idSubscriber){
    this.subscriberProfileService.getSelectboxList(this.idSubscriber, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
        .then(data => {
          this.profileOptions = data['subscriber_profiles'];
          let index = this.profileOptions.findIndex((profile) => {
            return profile.id === null
          });
          this.profileOptions[index].text = this.$gettext("Výchozí profil odběratele");
        })
        .then(() => {
          this.settingsLoaded = true;
        });
    }
    const settingsPromise = this.reloadSettings();
    if (this.isChannelsMode) {
      settingsPromise.then(() => this.loadSelectedBroadcastData());
    }
  },
  mounted() {
    this.afterLoad = true;
  },
  computed: {
    isOperatorEditGlobal(){
      return this.entity.global && this.$_loggedUser_selectedOperatorId
    },
    editableByOperator(){
      return this.editable;
    },
    editableByGlobal(){
      return this.isOperatorEditGlobal ? false: this.editable;
    },
    idSubscriber() {
      return this.$route.params.idSubscriber
    },
    isSubscriber() {
      return this.idSubscriber != null;
    },
    showOperatorSelect() {
      return !this.isSubscriber && this.$_updateActionAllowedAllOrOwnAndGlobal;
    },
    loaded() {
      return this.settingsLoaded && this.entity;
    },
    isCustomType() {
      return this.carouselType === 'custom';
    },
    isBroadcastsCustomType() {
      return this.carouselType === 'selected_broadcasts';
    },
    isShowsCustomType() {
      return this.carouselType === 'selected_shows';
    },
    isContentCustomType() {
      return this.isBroadcastsCustomType || this.isShowsCustomType;
    },
    isChannelsMode() {
      return this.selectionMode === 'channels';
    },
    isChannelType(){
      return this.carouselType === 'channels';
    },
    isTop10Type(){
      return this.carouselType === 'top_10_movies' || this.carouselType === 'top_10_series';
    },
    isMostViewedType(){
      return this.entity.type === 'most_viewed_broadcast';
    },
    isTop10ShowVariant(){
      return this.entity.show_variant === 'TOP_10';
    },
    idFormat: {
      get() {
        if(this.settingsLoaded) {
          if (this.entity.id_tags && this.formatTags) {
            let availableIds = this.formatTags.map((item) => item.id);
            return availableIds.filter(id => this.entity.id_tags.includes(id));
          } else {
            return [];
          }
        }else{
          return [];
        }
      },
      set(value) {
        this.entity.id_tags = value.concat(this.idContent);
      }
    },
    idContent: {
      get() {
        if (this.entity.id_tags && this.formatTags) {
          let availableIds = this.contentTags.map((item) => item.id);
          return availableIds.filter(id => this.entity.id_tags.includes(id));
        } else {
          return [];
        }
      },
      set(value) {
        this.entity.id_tags = value.concat(this.idFormat);
      }
    },
    operatorId: {
      get() {
        return Number(this.entity.id_operator);
      },
      set(newValue) {
        if (newValue != this.entity.id_operator && !this.entity.id) {
          this.entity.id_operator = newValue;
          this.entity.services = [];
          this.entity.id_channels = [];
          if (this.settingsLoaded) {
            this.reloadSettings();
          }
        }
      }
    },
    showVariantOptions() {
      return [
        {id: 'PORTRAIT', text: this.$gettext('Plakáty na výšku')},
        {id: 'WIDE', text: this.$gettext('Obrázky na šířku')},
        {id: 'ULTRA_WIDE', text: this.$gettext('Extra široké položky')},
        {id: 'BACKGROUND', text: this.$gettext('Pozadí')},
        {id: 'TOP_10', text: this.$gettext('Top 10')},
      ];
    },
    typeOptions() {
      return !this.entity.id ? [
          {id: 'custom', text: this.$gettext('Obsahový')},
          {id: 'selected_broadcasts', text: this.$gettext('Obsahový - vysílání')},
          {id: 'selected_shows', text: this.$gettext('Obsahový - pořady')},
          {id: 'channels', text: this.$gettext('Kanálový')},
          {id: 'most_viewed_broadcast', text: this.$gettext('Nejsledovanější pořady')},
      ]
          : [
        {id: 'tips', text: this.$gettext('Tipy')},
        {id: 'best_rated', text: this.$gettext('Nejlépe hodnocené')},
        {id: 'last_viewed', text: this.$gettext('Naposledy zhlédnuté pořady')},
        {id: 'pvrs', text: this.$gettext('Nahrávky')},
        {id: 'tags', text: this.$gettext('Štítky')},
        {id: 'favorites', text: this.$gettext('Oblíbené')},
        {id: 'periodic_pvrs', text: this.$gettext('Periodické nahrávky')},
        {id: 'custom', text: this.$gettext('Obsahový')},
        {id: 'selected_broadcasts', text: this.$gettext('Obsahový - vysílání')},
        {id: 'selected_shows', text: this.$gettext('Obsahový - pořady')},
        {id: 'channels', text: this.$gettext('Kanálový')},
        {id: 'last_channels', text: this.$gettext('Naposledy zhlédnuté kanály')},
        {id: 'menu', text: this.$gettext('Menu')},
        {id: 'most_viewed_broadcast', text: this.$gettext('Nejsledovanější pořady')},
        {id: 'top_10_movies', text: this.$gettext('Top 10 filmů')},
        {id: 'top_10_series', text: this.$gettext('Top 10 seriálů')},
      ];
    },
    maxYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    reloadSettings() {
      this.setLoadingMessage();
      const lang = iso6391ToIso6392(this.$store.getters.getLanguage)
      return this.dashboardCarouselService.getSettingsData({
        language: lang !== '' ? lang: 'cze',
        id_selected_operator: this.entity.id_operator,
        id_subscriber: this.idSubscriber,
        id_subscriber_profile: this.entity.id_subscriber_profile,
      })
          .then((data) => {
            this.formatTags = data['format'];
            this.contentTags = data['content'];
            this.countries = data['country'];
            this.channels = data['channels'];
            if(data.hasOwnProperty('channel_groups')){
              this.channelGroups = data['channel_groups'];
              this.channelGroups.unshift({'id': null, 'text': this.$gettext('Nenastavena')});
            }
            if(data.hasOwnProperty('thematic_groups')){
              this.thematicGroups = data['thematic_groups'];
              this.thematicGroups.unshift({'id': null, 'text': this.$gettext('Nenastavena')});
            }
          }).then(() => {
        this.settingsLoaded = true;
        this.emptyMessage(true);
      });
    },
    searchService(search, selectAll = false) {
      return this.serviceService.searchServicesByNameOrId({
        search: search,
        id_selected_operator: this.$store.getters.getSelectedOperatorId,
        select_all: selectAll
      });
    },
    searchShow(search, selectAll = false) {
      return this.dashboardCarouselService.searchShowsByName({name_search: search, language: iso6391ToIso6392(this.$store.getters.getLanguage)})
    },
    onChannelsToggle(ids) {
      this.entity.id_channels = ids;
      if (this.isChannelsMode) {
        this.loadSelectedBroadcastData();
      }
    },
    loadSelectedBroadcastData() {
      this.dashboardCarouselService.getSelectedBroadcastData({
        id_channels: this.entity.id_channels.map(channel => parseInt(String(channel).replace('channel-', ''), 10)),
        days_back: this.entity.days_back || 8,
      }).then(data => {
        if (this.isShowsCustomType) {
          this.entity.id_shows = data.shows.map(show => show.id);
          const shows = {};
          data.shows.forEach(show => {
            shows[show.id] = show;
          });
          this.entity.shows = shows;
        } else {
          this.entity.id_broadcasts = data.broadcasts.map(broadcast => broadcast.id);
          const broadcastNames = {};
          data.broadcasts.forEach(broadcast => {
            broadcastNames[broadcast.id] = broadcast;
          });
          this.$emit('broadcast-search-names', broadcastNames);
        }
      });
    },
    entityToCarouselType() {
      let type = this.entity.type
      if (this.entity.type === 'last_channels') {
        type = 'channels'
      }
      if (this.entity.type === 'custom' && this.entity.subtype) {
        type = this.entity.subtype
      }
      return type
    },
    entityToSelectionMode() {
      return (this.entity.id_channels && this.entity.id_channels.length) ? 'channels' : 'manual';
    },
    carouselTypeToEntity(value) {
      if (value === 'selected_broadcasts' || value === 'selected_shows') {
        this.entity.type = 'custom'
        this.entity.subtype = value
      } else {
        this.entity.type = value
        this.entity.subtype = null
      }

    },
    onTypeChange(){
      this.carouselTypeToEntity(this.carouselType);
      this.reloadSettings();

      this.selectionMode = 'manual';
      this.entity.show_variant = 'PORTRAIT';
      this.entity.services = [];
      this.entity.id_tags = [];
      this.entity.id_formats = [];
      this.entity.id_contents = [];
      this.entity.id_countries = [];
      this.entity.id_channels = [];
      this.entity.id_broadcasts = [];
      this.entity.id_shows = [];
      this.entity.rating = {};
      this.entity.year = {};
      this.entity.id_thematic_channel_group = null;
      this.entity.id_channel_group = null;
      this.entity.minimal_broadcast_length_minutes = null;
      this.entity.days_back = null;
    },
    onShowVariantChange(){
      if(this.entity.show_variant === 'TOP_10'){
        this.entity.dashboard_items_count = 10;
      }
    },
    onProfileChange(){
      if(this.isChannelType){
        this.reloadSettings();
      }
    },
    openThematicGroupDetail(idThematicGroup) {
      this.$router.push({
        name: 'thematicGroupDetail',
        params: {
          id: idThematicGroup
        }
      });
    },
    openChannelGroupDetail(idChannelGroup) {
      this.$router.push({
        name: 'channelGroupDetail',
        params: {
          id: idChannelGroup
        }
      });
    },
  },
  watch: {
    selectionMode() {
      if (!this.selectionModeInitialized) {
        return;
      }
      this.entity.id_channels = [];
      this.entity.id_broadcasts = [];
      this.entity.id_shows = [];
      this.entity.shows = {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/dashboardCarousels/detail/BasicInfo.vue